import { Component } from "@angular/core";

@Component({
  selector: "app-layout-panel",
  templateUrl: "./component.html",
  styleUrls: ["./component.css"],
})
export class LayoutWwwComponent {}
